// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Rana backend API
 * The API service for Rana.
 *
 * The version of the OpenAPI document: v1-alpha
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
/**
 *
 * @export
 * @interface EmbeddedVectorMeta
 */
export interface EmbeddedVectorMeta {
  /**
   *
   */
  featureTypeDefinition?: string | null;
}

/**
 * Check if a given object implements the EmbeddedVectorMeta interface.
 */
export function instanceOfEmbeddedVectorMeta(value: object): value is EmbeddedVectorMeta {
  return true;
}

export function EmbeddedVectorMetaFromJSON(json: any): EmbeddedVectorMeta {
  return EmbeddedVectorMetaFromJSONTyped(json, false);
}

export function EmbeddedVectorMetaFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): EmbeddedVectorMeta {
  if (json == null) {
    return json;
  }
  return {
    featureTypeDefinition:
      json["feature_type_definition"] === undefined
        ? undefined
        : json["feature_type_definition"] === null
        ? null
        : json["feature_type_definition"],
  };
}

export function EmbeddedVectorMetaToJSON(json: any): EmbeddedVectorMeta {
  return EmbeddedVectorMetaToJSONTyped(json, false);
}

export function EmbeddedVectorMetaToJSONTyped(
  value?: EmbeddedVectorMeta | null,
  ignoreDiscriminator: boolean = false
): any {
  if (value == null) {
    return value;
  }

  return {
    feature_type_definition: value["featureTypeDefinition"],
  };
}
